module.exports = __webpack_public_path__ + "img/background1.7e81514a.jpg";